<template>
	<div class="workbench">
		<div class="workbench0">
			<Breadcrumb></Breadcrumb>
		</div>
		<div class="work-container">
			<div class="work-container-L">
				<div class="work-container-l-per">
					<div class="work-container-l-per-item">
						<div style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
							<div
								style="width: 70px;height: 70px;border-radius: 50%;overflow: hidden;background: #f9f9f9;padding: 10px;">
								<img src="../../assets/img/logo3.png" style="width: 100%;height: 100%;">
							</div>
							<div
								style="font-family: Impact;font-size: 14px;color: #757475;margin: 10px 0 0px 0;display: flex;align-items: flex-end;">
								<div style="color: #409eff;">{{ workList.T_name }}</div>
								<div>，你好</div>
							</div>
							<div style="font-family: Georgia;font-size: 14px;color: #757475;" v-if="workList.T_pid > 0">
								<!-- -->
								宝智达科技已为您服务：<span style="color: #ee954d;margin-right:5px;font-size: 25px;">{{
									workList.T_Days }}</span>天
							</div>
						</div>

					</div>
					<div class="work-container-l-per-item" v-if="workList.T_pid > 0 && workList.WarningSign">
						<!-- v-if="workList.T_pid>0"  -->
						<div class="workbench1-L1" @click="routerLink('1', workList.WarningSign)">
							<el-progress type="dashboard" :percentage="Number(100)" color="#1E9FFF"
								:format="format1"></el-progress>
							<div class="workbench1-L1-txt">
								今日报警数量
							</div>
						</div>
						<div class="workbench1-L1" @click="routerLink('3', workList.WarningSign)">
							<el-progress type="dashboard" :percentage="Number(100)" color="rgb(255, 73, 73)"
								:format="format2"></el-progress>
							<div class="workbench1-L1-txt">
								未处理报警数量（近40天）
							</div>
						</div>
					</div>
					<div class="work-container-l-per-item" v-if="workList.T_pid == 0" v-permission="'WorkOrder'"
						@click="$router.push('/systemManagement/WorkOrder')">
						<div class="workbench1-L1">
							<el-progress type="dashboard" :percentage="Number(100)" color="#1E9FFF"
								:format="format3"></el-progress>
							<div class="workbench1-L1-txt">
								今日工单数量
							</div>
						</div>
						<div class="workbench1-L1">
							<el-progress type="dashboard" :percentage="Number(100)" color="#FFB800"
								:format="format4"></el-progress>
							<div class="workbench1-L1-txt">
								未处理工单
							</div>
						</div>
					</div>
					<div class="work-container-l-per-item" v-if="workList.T_pid > 0"><!-- 超级管理员不展示 -->
						<div class="workbench1-L1">
							<el-progress type="dashboard" :percentage="Number(100)" color="rgb(19, 206, 102)"
								:format="format5"></el-progress>
							<div class="workbench1-L1-txt">
								<span>余额</span>
								<span @click="centerDialogVisible = true"
									style="color: rgb(19, 206, 102);text-decoration: underline;cursor: pointer;">账单下载</span>
								<span @click="isShowMsg"
									style="color: rgb(19, 206, 102);text-decoration: underline;cursor: pointer;margin-left: 10px;">通知充值</span>
							</div>
						</div>
					</div>
					<div class="work-container-l-per-item" v-if="workList.T_pid > 0"><!-- 超级管理员不展示  -->
						<div class="workbench1-L1">
							<el-progress type="dashboard" :percentage="Number(100)" :format="format6"
								color="rgb(19, 206, 102)"></el-progress><!--  -->
							<div class="workbench1-L1-txt">
								本月通知记录（短信） <span @click="showMsg(1)"
									style="color: rgb(19, 206, 102);text-decoration: underline;cursor: pointer;">详情</span>
							</div>
						</div>
						<div class="workbench1-L1">
							<el-progress type="dashboard" :percentage="100" :format="format7"
								color="#FFB800"></el-progress><!--  -->
							<div class="workbench1-L1-txt">
								本月通知记录（电话） <span @click="showMsg(2)"
									style="color: #FFB800;text-decoration: underline;cursor: pointer;">详情</span>
							</div>
						</div>
					</div>
					<div class="work-container-l-per-item" v-permission="'Workbench:FlowPool'"> <!--  -->
						<div style="width: 100%;">
							<titles>
								<template slot="tit">
									流量池信息
								</template>
								<!-- <template slot="handle">
									查看详情
								</template> -->
							</titles>
							<div
								style="display: flex;align-items: center;justify-content: space-between;margin:10px 0;color: #999798;font-size: 14px;">
								<label>共{{ flowData.totalAmount ? flowData.totalAmount : 0 }}MB，已使用{{
									flowData.useAmount ? flowData.useAmount : 0
								}}MB</label>
								<label>剩余{{ flowData.remainAmount ? flowData.remainAmount : 0 }}MB</label>
							</div>
							<el-progress :percentage="flowSum()" :show-text="false"
								style="width:100%"></el-progress><!--  -->
						</div>
					</div>
					<div class="work-container-l-per-item" v-if="workList.T_pid > 0">
						<div style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
							<img src="../../assets/img/ServiceIt.png" style="width: 100px;height: 100px;">
							<el-popover placement="right" width="400" trigger="hover">
								<el-table :data="workList.Admin" height="250" border>
									<el-table-column property="T_name" label="专属工程师"></el-table-column>
									<el-table-column property="T_phone" label="联系方式"></el-table-column>
								</el-table>
								<el-button slot="reference" style="margin-top: 10px;"> 我的工程师</el-button>
							</el-popover>
						</div>
					</div>
					<div class="work-container-l-per-item" v-if="workList.T_pid == 0 && workList.T_pids != ''">
						<!-- 超级管理员不展示  -->
						<div class="workbench1-L1">
							<el-progress type="dashboard" :percentage="100" :format="format8"
								color="#FFB800"></el-progress><!--  -->
							<div class="workbench1-L1-txt">
								昨日报警率
							</div>
						</div>
					</div>
					<div class="work-container-l-per-item" v-if="workList.WarningSign"><!-- 我的消息  -->
						<div class="workbench1-L1" @click="routerLink('2', workList.WarningSign)">
							<!-- {{ workList }} -->
							<messages :data="workList.NewsNum"></messages>
						</div>
					</div>

				</div>

			</div>
			<div class="work-container-R">
				<div class="work-container-R-item3">
					<div class="workbench2-mai1">
						<div class="workbench2-tit" style="font-family: Impact;font-size: 35px;">
							<div style="color: #1e1e1e;">CONTACT</div>
							<div style="color: #a80303;margin-left: 20px;">US</div>
						</div>
						<div style="color: #757475;font-size: 20px;">联系我们</div>
					</div>
					<div class="workbench2-mai2">
						投诉电话：<div style="font-family: Arial Narrow;">18927494331</div>
					</div>
					<div class="workbench2-mai3">
						若服务不满意或建议，请进入
						<router-link to="/systemManagement/WorkOrderUser">工单系统</router-link>
						将在 24小时内处理
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="通知充值" :visible.sync="msgVisible" width="30%" :append-to-body="true">
			<el-steps :active="active" align-center>
				<el-step title="充值金额"></el-step>
				<el-step title="支付订单"></el-step>
				<el-step title="支付结果"></el-step>
			</el-steps>
			<el-divider></el-divider>
			<pay v-show="active == 1" @getPay="getPay" @setClose="closeFun"></pay>
			<qrCode v-show="active == 2" @getPay="getPay" :msgVisible="msgVisible"></qrCode>
			<results v-show="active == 3" @setClose="closeFun"></results>
		</el-dialog>
		<el-dialog title="账单下载" :visible.sync="centerDialogVisible" width="30%" :append-to-body="true">
			<el-form label-width="80px">
				<el-form-item label="下载时间">
					<el-date-picker v-model="T_month" :picker-options="pickerOptions" value-format="yyyy-MM"
						type="month" placeholder="请选择时间" :clearable="false">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button @click="centerDialogVisible = false">取 消</el-button>
					<el-button :disabled="T_month == '' ? true : false" type="primary" icon="el-icon-download"
						@click="onSubmit()">下载</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-drawer :title="params.T_ntype == 1 ? '短信通知' : '电话通知'" :append-to-body="true" :visible.sync="drawer"
			direction="rtl" size="50%">
			<div style="height: 95%; overflow: hidden;">
				<div style="margin-bottom: 50px;padding:0 20px 50px 20px; overflow: auto; height: 100%;"
					infinite-scroll-immediate="false" v-infinite-scroll="scrollLoad"
					infinite-scroll-disabled="scrdisabled">
					<el-table :data="tableData" style="width: 100%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<!-- <el-table-column prop="Id" label="通知号码" :show-overflow-tooltip="true">
						</el-table-column> -->
						<el-table-column prop="T_Notice" label="通知号码" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="T_tp_name" label="通知类型" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="CreateTime" label="发送时间" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="T_Remark" label="通知内容" :show-overflow-tooltip="true">
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div style="height: 5%;display: flex;align-items: center;justify-content: center">
				<div style="display: flex;align-items: center;">
					<i v-if="loadMores != '加载完成，没有其他数据了'" :class="loadings ? 'el-icon-loading' : 'el-icon-arrow-down'"
						style="font-size: 20px;"></i>
					<span style="padding-left: 5px;font-size: 10px;color: #666;">{{ loadMores }}</span>
				</div>
				<!-- <div v-if="loadMore" style="display: flex;align-items: center;"><span style="padding-left: 5px;font-size: 12px;color: #666;">滚动查看更多数据</span></div>
				<div v-if="loadstor" style="display: flex;align-items: center;"><span style="padding-left: 5px;font-size: 12px;color: #666;"></span></div> -->
			</div>
		</el-drawer>
	</div>
</div></template>

<script>
import titles from "./showTitle.vue"
import pay from './pay.vue'
import qrCode from './qr.vue'
import results from './results.vue'
import messages from './messages.vue'



import {
	workList,
	flowpool,
	downBill,
	record
} from "@/api/workbench.js"
import {
	mapGetters
} from "vuex"
import Axios from 'axios'
import fileDownload from 'js-file-download';
import { TimeData } from "@/plugins/timeFun.js";
export default {
	name: "workbench",
	computed: mapGetters(["permission"]),
	components: {
		titles,
		pay,
		qrCode,
		results, messages
	},
	data() {
		return {
			active: 1,
			msgVisible: false,
			scrdisabled: false,
			loadings: false,//加载中提示
			loadMores: "滚动查看更多数据",//滚动加载提示
			total: 0,
			params: {
				T_ntype: 1,
				page: 1,
				page_z: 20
			},
			drawer: false,
			centerDialogVisible: false,
			pickerOptions: { //限制选择当月之后的月份
				disabledDate: time => {
					return time.getTime() > Date.now();
				},
			},
			imgSrc: 'data:image/gif;base64,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',
			T_month: '',
			workList: {},
			flowData: {},
			tableData: []
		}
	},
	watch: {
		permission: {
			handler(val) {
				let key = val.indexOf('Workbench:FlowPool')
				if (key > -1) {
					this.GetflowpoolApi()
				}
			},
			deep: true, // 深度观察监听 设置为 true
			immediate: true, // 第一次初始化渲染就可以监听到
		},
		// drawer(val) {
		// 	if (!val) {
		// 		////console.log('关闭', val)
		// 		this.params.page = 1
		// 		this.tableData = []
		// 	}
		// }
	},
	created() {
		this.getWorkListApi()
	},
	mounted() { },
	methods: {
		routerLink(key, routerIt) {
			console.log('lingk', key)
			const obj = { T_handle: key == 2 ? '1' : key }
			switch (key) {
				case '1':
					obj.Time_start = TimeData(new Date(new Date().toLocaleDateString()).getTime())
					obj.Time_end = TimeData(new Date().getTime())
					break;
				case '2':
					obj.T_tp = [1003, 1002]
					break;
				default:
					break;
			}
			this.$router.push({
				name: routerIt,//'callthepolice'
				query: obj
			})
		},
		closeFun() {
			this.msgVisible = false
		},
		isShowMsg() {
			this.msgVisible = true;
			this.active = 1
		},
		getPay(e) {
			////console.log('传值',e)
			this.active = e
		},
		scrollLoad() {
			let that = this
			this.loadings = true
			this.loadMores = '加载中，请稍后'

			this.scrdisabled = true
			////console.log('===============================触底1')
			that.params.page += 1
			if (that.total < that.params.page) {
				that.loadings = false
				that.loadMores = '加载完成，没有其他数据了'
				that.scrdisabled = false
				return
			}

			that.upRecordApi()


		},
		showMsg(type) {
			this.params.page = 1
			this.tableData = []
			this.drawer = true
			this.params.T_ntype = type
			this.loadings = false
			this.loadMores = '加载完成，没有其他数据了'
			this.upRecordApi()
			////console.log('关闭', type)
		},
		upRecordApi() {
			var that = this
			////console.log('更新列表',this.params.page,this.total)

			record(this.params).then(res => {
				this.loadMore = false;
				if (res.data.Code == 200) {
					this.total = res.data.Data.Page_size
					let arr = res.data.Data.Data
					////console.log('更新列表',this.params.page,this.total)
					if (this.params.page == this.total) {//最后一页
						this.loadings = false
						this.loadMores = '加载完成，没有其他数据了'
					} else {
						this.loadings = false
						this.loadMores = '滚动查看更多数据'
					}
					this.tableData = [...this.tableData, ...arr]
					setTimeout(() => {
						that.scrdisabled = false
					}, 500)
				}


			})
		},
		onSubmit() {
			const loading = this.$loading({
				lock: true,
				text: '正在整理数据，请稍后...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let that = this
			downBill({
				T_month: this.T_month
			}).then(res => {
				if (res.data.Code == 200) {
					let resIt = res.data.Data
					if (res.data.Data != '') {
						let downName = resIt.split('/')
						Axios({
							method: 'get',
							url: res.data.Data,
							responseType: 'blob'
						}).then(resBlob => {
							loading.close()
							that.centerDialogVisible = false
							fileDownload(resBlob.data, downName[downName.length - 1]);
						});
					} else {
						this.$message.error('哎呀，缺少下载地址呀')
					}
				}
			})
		},
		format1() {
			if (this.workList.WarningNum == undefined) {
				return "0条"
			} else {
				return `${this.workList.WarningNum}条`
			}
		},
		format2() {
			return `${this.workList.UntreatedWarningNum}条`
		},
		format3() {
			return `${this.workList.WorkOrderNum}条`
		},
		format4() {
			return `${this.workList.UntreatedWorkOrderNum}条`
		},
		format5() {
			return `${this.workList.Balance}元`
		},
		format6() {
			////console.log('=============999', this.workList)
			return this.workList.NoticeRecord.Sms == undefined ? `0条` : `${this.workList.NoticeRecord.Sms}条`
		},
		format7() {
			return this.workList.NoticeRecord.Phone == undefined ? `0条` : `${this.workList.NoticeRecord.Phone}条`
		},
		format8() {
			return this.workList.WarningRate == undefined ? `0条` : `${this.workList.WarningRate}条`
		},
		flowSum() { //流量池的百分数
			if (this.flowData.remainAmount && this.flowData.totalAmount) {
				let amoutRem = Number(this.flowData.remainAmount)
				let totalSum = Number(this.flowData.totalAmount)
				let sum = ((amoutRem / totalSum) * 100).toFixed(0)
				return parseInt(sum)
			} else {
				return 0
			}
		},
		handleCommand() {
			this.$router.replace('/')
			this.$store.commit('setuserInfo', {
				username: '',
				password: '',
				token: ''
			})
		},
		GetflowpoolApi() {
			flowpool({}).then(res => {
				////console.log('无权访问', res)
				const {
					Data: resIt
				} = res.data.Data

				this.flowData = resIt
			})
		},
		getWorkListApi() {
			workList({}).then(res => {
				console.log('workList', res)
				if (res.data.Code === 200) {
					this.$store.dispatch('SETPANY', {
						plan: res.data.Data.CompanyKey,
						T_name: res.data.Data.CompanyName,
						bl: true,
						Id: res.data.Data.CompanyId,
					}) //缓存到vuex

					this.workList = res.data.Data
					// this.workList.NewsNum = 10
					localStorage.setItem('setPid', this.workList.T_pid)
					// console.log('进度条', this.workList.T_pid)
				}
			})
		}
	}
}
</script>

<style lang="scss">
.el-popconfirm__main {
	width: 100%;
	height: 22px;
	font-size: 16px;
	font-weight: 500;
	text-align: left;
	color: #333333;
	line-height: 22px;
	padding: 10px 5px 20px 5px;
}

.workbench {
	color: #545e6b;
	user-select: none;
	background: rgba(#f9f9f9, 1);

	.workbench0 {
		background: #fff;
		margin-bottom: 10px;
		padding: 20px 10px;
		box-shadow: 0 5px 10px -10px #000;
	}

	.work-container {
		min-height: 250px;
		padding: 10px;
		display: flex;
		flex-direction: column;

		// display: grid;
		// grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
		// grid-gap: 10px;
		.work-container-L {
			.work-container-L-pro {
				background: #fff;
				border-radius: 10px;
				padding: 20px;
				margin-top: 15px;

			}

			.work-container-l-per {
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
				grid-gap: 10px 10px;

				.work-container-l-per-item {
					height: 200px;
					background: #fff;
					border-radius: 10px;
					padding: 20px;
					display: flex;
					align-items: center;
					justify-content: space-around;
					transition: all .2s;

					.workbench1-L1 {
						margin: 0 10px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;

						.workbench1-L1-txt {
							color: #999;
							font-size: 14px;
							font-weight: 500;
						}

						.workbench1-L1-quan1 {
							width: 100px;
							height: 100px;
							border-radius: 50%;
							border: 6px solid rgb(32, 160, 255);
							display: flex;
							align-items: center;
							justify-content: center;
							color: rgb(96, 98, 102);
							box-shadow: 0 0 10px 0 #ccc;
						}

						.workbench1-L1-quan2 {
							width: 100px;
							height: 100px;
							border-radius: 50%;
							border: 6px solid red;
							display: flex;
							align-items: center;
							justify-content: center;
							color: rgb(96, 98, 102);
						}
					}
				}

				.work-container-l-per-item:hover {
					cursor: pointer;
					transform: scale(.9);
					z-index: 1;
					box-shadow: 0 0 10px 0 #ccc;
				}
			}
		}

		.work-container-R {
			.work-container-R-item2 {
				border-radius: 10px;
				background: #fff;
				padding: 20px;

			}

			.work-container-R-item3 {
				margin-top: 10px;
				border-radius: 10px;
				background: #fff;
				margin-bottom: 10px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 60px 0;

				.workbench2-mai1 {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					.workbench2-tit {
						display: flex;
						align-items: center;
					}
				}

				.workbench2-mai2 {
					display: flex;
					align-items: center;
					color: rgba(#757475, .8);
					margin: 20px 0 0 0;
					font-family: Impact;
					font-size: 20px;
					font-weight: 100;
				}

				.workbench2-mai3 {
					color: #909399;
					font-size: 12px;
					margin-top: 5px;
					opacity: .8;

					a {
						color: #a80303;
						padding: 0 5px;
					}
				}
			}
		}
	}
}
</style>